import React, { PureComponent } from 'react';
import { Col, Container, Row } from 'reactstrap';

import { withTranslation } from 'react-i18next';
import { map, sum } from 'lodash';

class AnalysisSummary extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { t, summaryData } = this.props;
    let i = 1;

    return (
      <Col lg={6} xs={12} sm={6}>
        <div className="white-bg">
          <div className="title-details">
            <Col lg={9} sm={9} xs={9}>
              <h4>{t('dashboard_assets.ai_analysis_summary_title')}</h4>
            </Col>
            <Col lg={3} sm={3} xs={3} className="text-right">
            </Col>
          </div>
          <div className="row pro">
            {
              map(summaryData, (val, key)=>(
                <div className="col-lg-6 col-sm-8 col-md-6 col-xs-12">
                  <div className="small-line">
                    <div className="col-lg-5 xs-center col-sm-5 col-xs-12">
                      <img src={'img/icon-'+ i++ +'.png'} alt="" />
                    </div>
                    <div className="col-lg-7 flush xs-center col-sm-7 col-xs-12">
                      <h5>{val}</h5>
                      <p>{key}</p>
                    </div>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </Col>

    );
  }
}


export default withTranslation('common')(AnalysisSummary);
